import { queryOptions } from '@tanstack/react-query'

import { fetchLeaderboard, fetchSettings } from '#admin/features/voting/api.ts'

export const votingSettingsQuery = () =>
  queryOptions({
    queryKey: ['voting', 'settings'],
    queryFn: ({ signal }) => fetchSettings(signal),
  })

/**
 * The standings refetch on a timer while the page is open.
 *
 * A leaderboard is the one screen in this console somebody leaves on a display, and a figure
 * that only moves on reload reads as broken. Thirty seconds rather than a socket: the numbers
 * change at the speed visitors walk, and a WebSocket would be infrastructure for a page nobody
 * watches for latency.
 */
export const leaderboardQuery = () =>
  queryOptions({
    queryKey: ['voting', 'leaderboard'],
    queryFn: ({ signal }) => fetchLeaderboard(signal),
    refetchInterval: 30_000,
  })
